export default class WebsiteVisitorAnalytics {
	private static instance: WebsiteVisitorAnalytics; 
	private static localStorageReferrerKey = "WebsiteVisitorAnalytics.referrer";

	static getInstance(): WebsiteVisitorAnalytics {
		if (WebsiteVisitorAnalytics.instance === undefined) {
			WebsiteVisitorAnalytics.instance = new WebsiteVisitorAnalytics();
		}
		return WebsiteVisitorAnalytics.instance;
	}

	private constructor() {
		this.checkReferrer();
		this.setValueToFields();
	}

	private checkReferrer() {
		let thirdParyReferrer;
		if (document.referrer !== undefined && document.referrer.length !== 0) {
			const tmp = document.createElement("a");
			tmp.href = document.referrer;
			const referrerHostname = tmp.hostname;
			if (referrerHostname !== window.location.hostname) {
				thirdParyReferrer = document.referrer;
			} else {
				// Navigation within the same site so don't record as a third-party referrer.
			}
		} else {
			thirdParyReferrer = "Direct / Unknown";
		}

		if (thirdParyReferrer !== undefined) {
			this.addReferrerToStorage(thirdParyReferrer, window.location.href);
		}
	}

	private addReferrerToStorage(referrer: string, location: string) {
		try {
			const dataString = window.localStorage.getItem(WebsiteVisitorAnalytics.localStorageReferrerKey);
			let data: {referrer: string, location: string}[];
			if (dataString !== null) {
				data = JSON.parse(dataString);
			} else {
				data = [];
			}

			data.push({referrer: referrer, location: location});
			const newDataString = JSON.stringify(data);

			window.localStorage.setItem(WebsiteVisitorAnalytics.localStorageReferrerKey, newDataString);
		} catch (err) {
			console.error("Error adding to local storage", err); // TODO Or should I let it error. My concern is web page breaking cause of a JSON parsing issue.
		}
	}

	private getBrowserData(): string {
		const data = {
			hasJavaScript : true,
			"window.innerWidth" : window.innerWidth,
			"window.innerHeight" : window.innerHeight
		};
		return JSON.stringify(data);
	}

	private setValueToFields() {
		// Referrrer
		let fields = document.querySelectorAll(".websiteVisitorAnalyticsReferrer");
		if (fields.length === 0) {
			return;
		}

		let dataString = window.localStorage.getItem(WebsiteVisitorAnalytics.localStorageReferrerKey);
		for (let i = 0; i < fields.length; i++) {
			const field = fields[i];
			if (field instanceof HTMLInputElement) {
				field.value = dataString;
			}
		}

		// Browser Data
		fields = document.querySelectorAll(".websiteVisitorBrowserData");
		if (fields.length === 0) {
			return;
		}

		dataString = this.getBrowserData();
		for (let i = 0; i < fields.length; i++) {
			const field = fields[i];
			if (field instanceof HTMLInputElement) {
				field.value = dataString;
			}
		}
	}

}